<template>
  <App>
    <datatable
        :filters="filters"
        :headers="headers"
        :items="projetosTable"
        :loading="form.processing"
        v-if="!processing"
        singleSearch
    >
      <template #filters>
        <div class="card-title">
          <div class="d-flex align-items-center position-relative">
                        <span class="position-absolute ms-6">
                            <i class="fas fa-search"></i>
                        </span>
            <input data-kt-customer-table-filter="search"
                   v-model="filters.search"
                   type="text"
                   class="form-control form-control-solid w-450px ps-15"
                   placeholder="Busque por algo"
            />
          </div>
        </div>
        <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
          <a href="#" @click="gerarAvaliadores" v-if="geraAvaliadores && can('ADM')" class="btn btn-sm btn-info">Gerar Avaliadores</a>
          <a href="#" @click="gerarMesas" v-if="can('ADM')" class="btn btn-sm btn-info">Gerar Mesas</a>
        </div>
      </template>

      <template v-slot:cell.nome="{row}">
       <p>{{ row.id }} - {{ row.nome }}</p>
        <p class="mb-1">
          <span class="badge badge-primary me-2">{{ row.escola.nome }}</span>
        </p>
        <p class="mb-1">
          <span class="badge badge-dark mt-2 me-2">{{ row.categoria?.nome }}</span>
          <span class="badge badge-info mt-2 me-2">{{ row.ano_escolaridade.nome }}</span>
        </p>

        <p class="mb-1">
          <span class="badge badge-success mt-2 me-2" :class="{'badge-danger': !row.InscricaoResumo}">{{ row.InscricaoResumo ? 'Resumo Enviado' : 'Resumo não enviado' }}</span>
          <span class="badge badge-success mt-2 me-2" :class="{'badge-danger': !row.InscricaoBanner}">{{ row.InscricaoBanner ? 'Pôster Enviado' : 'Pôster não enviado' }}</span>
        </p>

        <p class="mb-1" v-if="can('ADM') && row.avaliacao">
          <span class="badge badge-primary mt-2 me-2">Situação da Avaliação: {{ row.avaliacao.situacao_avaliacao_resumo }}</span>
          <span class="badge badge-dark mt-2 me-2" v-if="row.avaliacao.avaliacao_resumo.nota">Nota Resumo: {{ row.avaliacao.avaliacao_resumo.nota }}</span>
          <span class="badge badge-info mt-2 me-2" v-if="row.avaliacao.avaliacao_projeto.nota">Nota Projeto: {{ row.avaliacao.avaliacao_projeto.nota }}</span>
        </p>

        <!--        <p v-if="row.avaliacao">-->
<!--          <span class="badge badge-success" v-if="row.avaliacao.situacao === 3">Este projeto está aprovado.</span>-->
<!--          <span class="badge badge-danger" v-if="row.avaliacao.situacao === 4">Este projeto está reprovado.</span>-->
<!--        </p>-->
      </template>

      <template v-slot:cell.orientador="{row}">
        <p>{{ row.orientador.nome }}</p>
        <div v-if="row.coorientador" class="separator my-4"></div>
        <p v-if="row.coorientador">{{ row.coorientador.nome }}</p>
      </template>

      <template v-slot:cell.alunos="{row}">
        <p class="fs-7" v-for="aluno in row.alunos">{{aluno.nome}}</p>
      </template>

      <template v-slot:cell.actions="{row}">
        <Link :href="this.route('app.projetos.edit', row.id)"
              v-if="can(['ADM', 'ORI'])"
              method="get"
              as="button"
              @click="disposeTooltip()"
              type="button"
              class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              title="Editar o projeto"
              data-bs-original-title="Ver projeto">
          <i class="fs-2 bi bi-pencil-square"></i>
        </Link>

        <a href="#" @click="trocarAvaliador(row); disposeTooltip()" v-if="row.avaliadores.length > 0 && can('ADM')"
           class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
           data-bs-toggle="tooltip"
           data-bs-trigger="hover"
           title="Trocar Avaliador">
          <i class="fs-2 bi bi-arrow-repeat"></i>
        </a>

        <a href="#" @click="adicionaAvaliadorMesa(row); disposeTooltip()" v-if="can('ADM')"
           class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
           data-bs-toggle="tooltip"
           data-bs-trigger="hover"
           title="Adiciona avaliador da Mesa">
          <i class="fs-2 bi bi-person-plus"></i>
        </a>

        <a href="#" @click="verAvaliacao(row.id); disposeTooltip()" v-if="row.avaliacao && can('ADM')"
           class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
           data-bs-toggle="tooltip"
           data-bs-trigger="hover"
           title="Ver Avaliação">
          <i class="fs-2 bi bi-award-fill"></i>
        </a>

        <a @click="disposeTooltip()" :href="route('app.projetos.download-doc', [row.id, 'resumo'])" v-if="row.InscricaoResumo && can('ADM')"
              class="btn btn-sm btn-clean btn-icon"
              target="_blank"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              title="Download Resumo">
          <i class="fs-2 bi bi-download text-primary"></i>
        </a>

        <a @click="disposeTooltip()" :href="route('app.projetos.download-doc', [row.id, 'poster'])" v-if="row.InscricaoBanner && can('ADM')"
           class="btn btn-sm btn-clean btn-icon"
           target="_blank"
           data-bs-toggle="tooltip"
           data-bs-trigger="hover"
           title="Download Poster">
          <i class="fs-2 bi bi-download text-primary"></i>
        </a>

        <a :href="this.route('app.projetos.corrige-projeto', row.id)"
           v-if="permiteCorrigirResumo(row.avaliacao) && orientador(row.Orientador_ID)"
           class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
           data-bs-toggle="tooltip"
           data-bs-trigger="hover"
           title="Corrigir projeto / Ver avaliação">
          <i class="fs-2 bi bi-pencil"></i>
        </a>

        <Link :href="this.route('app.projetos.documentos', row.id)"
              method="get"
              as="button"
            @click="disposeTooltip()"
            v-if="can(['ADM', 'ORI'])"
            class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
            data-bs-toggle="tooltip"
            data-bs-trigger="hover"
            title="Enviar Documentos">
          <i class="fs-2 bi bi-upload"></i>
        </Link>

        <a href="#" @click="remove(row.id); disposeTooltip()" v-if="can('ADM')"
           class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
           data-bs-toggle="tooltip"
           data-bs-trigger="hover"
           title="Excluir Projeto">
          <i class="fs-2 bi bi-trash"></i>
        </a>

        <a href="#" @click="adicionarPendencias(row); disposeTooltip()" v-if="can('ADM')"
           class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
           data-bs-toggle="tooltip"
           data-bs-trigger="hover"
           title="Adicionar Pendências">
          <i class="fs-2 bi bi-bounding-box-circles"></i>
        </a>
      </template>
    </datatable>
    <h4 v-else>
      <p v-if="projetosTable.length">Estamos buscando os projetos...</p>
      <p v-else>Você ainda não tem projetos inscritos, clique no botão ao lado para inscrever.</p>
    </h4>
  </App>
</template>
<script>
import App from "@layout/App";
import axios from "axios";
import {shallowRef, ref, markRaw, reactive} from "vue";
import {Link, useForm} from "@inertiajs/inertia-vue3";
import Datatable from "@forms/Datatable";
import SubmitButton from "@forms/SubmitButton";
import Datepicker from "@forms/Datepicker";
import FormGroup from "@forms/FormGroup";
import {success, error} from "@settings/toastr";
import ModalTrocarAvaliador from "./ModalTrocarAvaliador";
import ModalAdicionaAvaliadorMesa from "./ModalAdicionaAvaliadorMesa";
import ModalAdicionaPendencias from "./ModalAdicionaPendencias.vue";
import ModalExibeAvaliacoes from "./ModalExibeAvaliacoes.vue";

export default {
  props: ['projetos', 'banca'],

  components: {
    FormGroup,
    Datepicker,
    SubmitButton,
    App,
    Link,
    Datatable,
    ModalTrocarAvaliador,
    ModalAdicionaAvaliadorMesa,
    ModalAdicionaPendencias
  },

  data: _ => ({
    headers: [
      {text: 'ID', value: 'id', hidden: true},
      {text: 'Código - Projeto - Escola', value: 'nome', width: 'w-450px', searchable: true},
      {text: 'Mesa', value: 'mesa', width: 'w-85px', searchable: true},
      {text: 'Orientador / Coorientador', value: 'orientador', searchable: true},
      {text: 'Alunos', value: 'alunos', searchable: true},
      {text: 'Ações', value: 'actions'},
    ],
    filters: {
      search: '',
    },
    geraAvaliadores: true,
    projetoId: null,
    projetoSelecionado: null,
    avaliadores: null,
    processing: true,
    projetosTable: []
  }),

  mounted() {
    this.init();
  },

  setup(props) {
    const form = useForm({
      projeto: null,
    });

    return {
      form
    }
  },

  methods: {
    orientador(orientadorId) {
      return this.$page.props.globalVar.orientadorID === orientadorId
    },

    permiteCorrigirResumo(avaliacao) {
      if (!avaliacao) {
        return false
      }

      return avaliacao.permite_corrigir_resumo
    },

    init() {
      if (this.projetos.links) {
        this.projetosTable.push(...this.projetos.data)
      } else {
        this.projetosTable.push(...this.projetos)
      }

      this.geraAvaliadores = !this.banca.avaliadores_gerados
      this.emitter.emit('title', 'Projetos');
      this.emitter.emit('breadcrumb', [
        {title: 'Dashboard', link: 'app.home'},
        {title: 'Projetos'},
      ]);

      this.emitter.emit('action',
          [{
            show: true,
            title: 'Nova Pré-Inscrição',
            link: this.route('app.projetos.create')
          }]
      );

      this.emitter.on('notas-changed', (data) => {
        let indexProjeto = this.projetosTable.findIndex(projeto => projeto.id === data.projeto.id)
        this.projetosTable[indexProjeto] = data.projeto
      })

      this.loadAvaliadores()

      if (this.projetos.links) {
        this.loadProjetos(this.projetos.links.next)
      } else {
        this.processing = false
      }
    },

    loadAvaliadores() {
      axios.get(this.route('app.avaliadores.json.banca_avaliadora_avaliadores')).then(response => {
        this.avaliadores = response.data
      })
    },

    loadProjetos (nextLink) {
      if (nextLink) {
        axios.get(nextLink).then(response => {
          this.projetosTable.push(...response.data.data)
          this.loadProjetos(response.data.links.next)
        })
      } else {
        this.processing = false
      }
    },

    clearFilters() {
      Object.keys(this.filters).forEach(k => this.filters[k] = null);
    },

    list() {
      axios.get(this.route('app.projetos.filter'))
          .then(response => this.projetosTable = response.data)
    },

    remove(id) {
      this.form.projeto = id;
      this.emitter.emit('alert', {
        success: this.confirmDelete
      });
    },

    trocarAvaliador(row) {
      this.emitter.emit('modal', {
        persistent: true,
        size: 'large',
        component: shallowRef(ModalTrocarAvaliador),
        componentProps: {projeto: row, avaliadores: this.avaliadores},
        btnSuccess: {
          hide: false,
          text: 'Alterar Avaliador',
          closeOnClick: false,
          click: () => this.emitter.emit('click-save')
        },
        centered: false,
        title: 'Trocar Avaliador',
      });
    },

    adicionaAvaliadorMesa(row) {
      this.emitter.emit('modal', {
        persistent: true,
        size: 'large',
        component: shallowRef(ModalAdicionaAvaliadorMesa),
        componentProps: {projeto: row, avaliadores: this.avaliadores},
        btnSuccess: {
          hide: false,
          text: 'Salvar',
          closeOnClick: true,
          click: () => this.emitter.emit('adiciona-avaliadores-mesa')
        },
        centered: false,
        title: 'Adicionar Avaliador para Mesa',
      });
    },

    adicionarPendencias(row) {
      this.emitter.emit('modal', {
        persistent: true,
        size: 'large',
        component: shallowRef(ModalAdicionaPendencias),
        componentProps: {projeto: row},
        btnSuccess: {
          hide: false,
          text: 'Salvar',
          closeOnClick: true,
          click: () => this.emitter.emit('adiciona-pendencias')
        },
        centered: false,
        title: 'Adicionar Pendências ao Projeto',
      });
    },

    verAvaliacao(projetoId) {
      this.emitter.emit('modal', {
        persistent: true,
        size: 'large',
        component: shallowRef(ModalExibeAvaliacoes),
        componentProps: {projetoId: projetoId},
        btnSuccess: {
          hide: true,
          text: 'Salvar',
          closeOnClick: true,
          click: () => ''
        },
        centered: false,
        title: 'Avaliação do Projeto',
      })
    },

    confirmDelete() {
      this.form.delete(this.route('app.projetos.delete', {id: this.form.projeto}), {
        onError: error,
        onSuccess: () => {
          success('Usuário excluído com sucesso!');
          this.clearFilters()
          this.list()
        }
      });
    },

    gerarAvaliadores() {
      this.emitter.emit('alert', {
        title: 'Confirme a ação',
        text: 'Você tem certeza que deseja gerar os avaliadores para cada projeto? Só é possível executar essa ação uma única vez.',
        icon: 'warning',
        success: this.confirmGerarAvaliadores
      });
    },

    gerarMesas() {
      this.emitter.emit('alert', {
        title: 'Confirme a ação',
        text: 'Você tem certeza que deseja gerar as mesas para cada projeto?',
        icon: 'warning',
        success: this.confirmGerarMesas
      });
    },

    confirmGerarAvaliadores() {
      this.geraAvaliadores = false
      axios.post(this.route('app.projetos.atribui-avaliadores')).then(response => {
        success('Avaliadores atribuidos aos projetos com sucesso!');
        setTimeout( () => {
          window.location.reload()
        }, 2000)
      }).catch(erro => {
        error({error: 'Não foi possível gerar os avaliadores, contate o suporte.'})
      })
    },

    confirmGerarMesas() {
      axios.post(this.route('app.projetos.gerar-mesas')).then(response => {
        success('Mesas geradas aos projetos com sucesso!');
        setTimeout( () => {
          window.location.reload()
        }, 2000)
      }).catch(erro => {
        error({error: 'Não foi possível gerar as mesas, contate o suporte.'})
      })
    },
  },
};
</script>

<style>
  .swal-wide {
    width:850px !important;
  }
</style>
